import type { FeatureFlag } from './types';

export function canDeprecateFlag(flag: FeatureFlag) {
  return !!flag.clientSideAvailability?.usingMobileKey || !!flag.clientSideAvailability?.usingEnvironmentId;
}
